module.formDirective('durationOfStayForm2', function() {
    return {
        modelName: 'student',
        subModel: 'duration_of_stay',
        templateDirectory: 'students/enrollment',
        scope: {
            next: '=',
            previous: '=',
        },
        copyData: function(scope) {
            return {
                exit_reason: angular.copy(scope.model.duration_exit_reason),
                duration_end: angular.copy(scope.model.duration_end),
                participant_email: angular.copy(scope.rootModel.participant_email) || undefined,
                exit_description: angular.copy(scope.model.exit_description),
                return_date: scope.next ? angular.copy(scope.next.duration_start) : undefined,
            };
        },

        link: function(scope, element, attrs, basicForm) {
            scope.disabledOptions = {};
            scope.disabledOptions.successful = "Cannot change this status " +
                "to successful because the student has returned after this " +
                "exit.  Please change or remove a later status.";
        },

        allowDelete: function(scope) {
            return !scope.next.duration_end;
        },

        delete: function(model, scope) {
            return scope.next.$delete();
        }
    };
});

module.directive('durationOfStayForm', function(ModelService) {
    var fields = ['duration_exit_reason', 'duration_end', 'exit_description'];
    return {
        restrict: 'E',
        templateUrl: 'students/enrollment/durationOfStayForm',
        scope: {duration: '=', previous: '=', next: '='},
        require: '^basicForm',
        link: function(scope, element, attrs, basicForm) {
            scope.disabledOptions = {};
            scope.disabledOptions.successful = "Cannot change this status " +
                "to successful because the student has returned after this " +
                "exit.  Please change or remove a later status.";
            scope.data = ModelService.copyFields(scope.duration, fields);
            scope.data.next = {
                duration_start: angular.copy(scope.next.duration_start),
            };
            basicForm.data = scope.data;
            scope.form = basicForm.getForm()

            basicForm.save = function(data) {
                return ModelService.patchModel(scope.duration, data);
            };

            basicForm.setDeleteFunctions(function() {
                return ModelService.deleteModel(scope.next);
            }, function() {
                return !scope.next.duration_end;
            });
        }
    };
});